import alertIcon from './alert.js';
import arrowKeysDownSelected from './arrowkeys_down_selected.js';
import arrowKeysUnselected from './arrowkeys_unselected.js';
import arrowKeysUpSelected from './arrowkeys_up_selected.js';
import arrowLeft from './arrowleft.js';
import arrowRight from './arrowright.js';
import blogIcon from './blog.js';
import calendarIcon from './calendar.js';
import checkmarkIcon from './checkmark.js';
import chevronDownIcon from './chevrondown.js';
import chevronLeftIcon from './chevronleft.js';
import chevronLeftWithCircleIcon from './chevronleft_withcircle.js';
import chevronLeftWithCircleFilledIcon from './chevronleft_withcircle_filled.js';
import chevronRightWithCircleIcon from './chevronright_withcircle.js';
import chevronRightWithCircleFilledIcon from './chevronright_withcircle_filled.js';
import chevronupIcon from './chevronup.js';
import closeIcon from './close.js';
import collapseIcon from './collapse.js';
import combinedShapeIcon from './combined_shape.js';
import contactIcon from './contact.js';
import dotIcon from './dot.js';
import editIcon from './edit.js';
import expandIcon from './expand.js';
import externalIcon from './external.js';
import facebookIcon from './facebook.js';
import groupBenefitsIcon from './group_benefits.js';
import infoIcon from './info.js';
import instagramIcon from './instagram.js';
import linkedinIcon from './linkedin.js';
import membersIcon from './members.js';
import minusIcon from './minus.js';
import minusWithCircleIcon from './minus_withcircle.js';
import moneyIcon from './money.js';
import mortgagesIcon from './mortgages.js';
import navIconAccountsIcon from './nav_icon_account.js';
import plusIcon from './plus.js';
import plusWithCircleIcon from './plus_withcircle.js';
import printIcon from './print.js';
import questionWithCircleIcon from './question_withcircle.js';
import questionWithCircleFilledIcon from './question_withcircle_filled.js';
import sadIcon from './sad.js';
import securitiesIcon from './securities.js';
import selectedDotIcon from './selected_dot.js';
import signInIcon from './signin.js';
import twitterIcon from './twitter.js';
import youtubeIcon from './youtube.js';

var ManulifeIcons = {
  alert: alertIcon,
  arrowkeys_up_selected: arrowKeysUpSelected,
  arrowkeys_down_selected: arrowKeysDownSelected,
  arrowkeys_unselected: arrowKeysUnselected,
  arrowleft: arrowLeft,
  arrowright: arrowRight,
  blog: blogIcon,
  calendar: calendarIcon,
  checkmark: checkmarkIcon,
  chevrondown: chevronDownIcon,
  chevronleft_withcircle_filled: chevronLeftWithCircleFilledIcon,
  chevronleft_withcircle: chevronLeftWithCircleIcon,
  chevronright_withcircle: chevronRightWithCircleIcon,
  chevronright_withcircle_filled: chevronRightWithCircleFilledIcon,
  chevronleft: chevronLeftIcon,
  chevronup: chevronupIcon,
  close: closeIcon,
  dot: dotIcon,
  combined_shape: combinedShapeIcon,
  contact: contactIcon,
  collapse: collapseIcon,
  edit: editIcon,
  expand: expandIcon,
  external: externalIcon,
  facebook: facebookIcon,
  groupBenefits: groupBenefitsIcon,
  info: infoIcon,
  instagram: instagramIcon,
  linkedin: linkedinIcon,
  members: membersIcon,
  minus_withcircle: minusWithCircleIcon,
  minus: minusIcon,
  money: moneyIcon,
  mortgages: mortgagesIcon,
  nav_icon_account: navIconAccountsIcon,
  plus_withcircle: plusWithCircleIcon,
  plus: plusIcon,
  print: printIcon,
  question_withcircle_filled: questionWithCircleFilledIcon,
  question_withcircle: questionWithCircleIcon,
  sad: sadIcon,
  securities: securitiesIcon,
  selected_dot: selectedDotIcon,
  signin: signInIcon,
  twitter: twitterIcon,
  youtube: youtubeIcon
};
var ManulifeIcons$1 = ManulifeIcons;

export { ManulifeIcons, ManulifeIcons$1 as default };
